import { createSlice } from "@reduxjs/toolkit";

const patientSlice = createSlice({
    name: "patients",
    initialState: {},
    reducers: {
        registerPatient: (state, action) => {
            const patient = action.payload;
            if (patient?.id) {
                state[patient.id] = patient;
            }
        },
        bulkRegisterPatients: (state, action) => {
            action.payload.forEach((patient) => {
                if (patient?.id) {
                    state[patient.id] = patient;
                }
            });
        }
    }
});

export const { registerPatient, bulkRegisterPatients } = patientSlice.actions;
export default patientSlice.reducer;